import './module.js';


var _globalscope;

if (typeof window !== 'undefined') {
	_globalscope = window;		
}
else if (typeof global !== 'undefined') {
	_globalscope = global;
}

_globalscope.simplestore.BigNumber = require('bignumber.js');